
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicContentsApi extends BaseModulePublicApi {
  basePath = 'contents';
};
